import React from 'react'
import { GoalsHelpPanel } from '../../../features/goals'
import { GOALS_PATH_RE } from './rightSidebarVisibility'

interface RightSidebarContentProps {
  activeTabPath?: string
}

/**
 * Inhalt der rechten Sidebar — inzwischen nur noch das Hilfe-Panel zu „Ziele".
 *
 * Früher wählte diese Komponente je nach Pfad zwischen Widgets (Kalender, Kurz
 * notiert, Aufgaben-Details). Die rechte Sidebar gibt es außerhalb von „Ziele"
 * nicht mehr, also ist von der Auswahl nur der eine Fall übrig. Die Widgets
 * selbst sind inzwischen weg — der Kommentar behauptete ihren Abbau bis
 * 2026-09-08 als offene Aufgabe, obwohl im Code keiner mehr stand.
 *
 * Der Lebensbereich kommt aus dem Pfad, nicht aus `activeLifeSpace`: der kann
 * 'all' sein, das Panel braucht aber einen konkreten.
 */
export const RightSidebarContent: React.FC<RightSidebarContentProps> = ({ activeTabPath }) => {
  const goalsMatch = activeTabPath?.match(GOALS_PATH_RE)
  if (!goalsMatch) return null

  return <GoalsHelpPanel lifeSpace={goalsMatch[1] as 'personal' | 'work' | 'home'} />
}
